import { useCallback } from 'react';

import SupplierListItem, { SupplierListItemProps } from './SupplierListItem';
import { SupplierStatus } from './SupplierStatus';

const defaultStyles = 'supplier-list block-grid-xs-2 block-grid-md-3 block-grid-condensed pad-t-3';

export interface SupplierListProps {
    isVerticallyAligned: boolean;
    className: string;
    supplierStatuses: SupplierStatus[];
    disabled: boolean;
    statusChanger: (SupplierStatus) => void;
    suffix: string;
}

export default function SupplierList(props: SupplierListProps) {
    const StatusUpdater = useCallback(
        (ss: SupplierStatus) => {
            const newStatuses = [...props.supplierStatuses];
            newStatuses.find(nss => nss.supplier === ss.supplier).checked = ss.checked;
            props.statusChanger(newStatuses);
        },
        [props]
    );

    function RenderSupplierListItem() {
        return props.supplierStatuses.map(s => {
            const itemProps = {
                status: s,
                disabled: props.disabled,
                isVerticallyAligned: props.isVerticallyAligned,
                statusUpdater: StatusUpdater,
                suffix: props.suffix
            } as SupplierListItemProps;
            return <SupplierListItem {...itemProps} key={`other-supplier-${s.supplier.id}`} />;
        });
    }

    return props.isVerticallyAligned ? (
        <>{RenderSupplierListItem()}</>
    ) : (
        <ul className={props.className || defaultStyles}>{RenderSupplierListItem()}</ul>
    );
}
